// Passive event listeners
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

/* This is your custom Javascript */
jQuery(document).ready(function() {
	$header = jQuery('.site-header');
	$adminBar = jQuery('#wpadminbar');
	$lessonPage = jQuery('.sfwd-lessons-template-default');
	$body = jQuery('body');
	$bb_course_video = jQuery('.bb-course-video-overlay-iframe' );

	if ($header.length && $lessonPage.length == 0) {
		var last_scroll=0;
		var current_scroll=0;
		var delta=5;

		var headerTop = $header.offset().top ?? 0,
			isMobile = window.matchMedia("only screen and (max-width: 767px)").matches,
			sidebarHeight = jQuery('.bb-ld-sticky-sidebar').height();
			if (sidebarHeight) {
				sidebarOffset = jQuery('.bb-ld-sticky-sidebar').offset().top + sidebarHeight - 200;
			}

		jQuery(window).bind('scroll', function (e) {

			current_scroll = jQuery(window).scrollTop();

			/*
			if(Math.abs(last_scroll - current_scroll) <= delta)
					return;
			*/

			if (current_scroll > headerTop && last_scroll > current_scroll) {
				$adminBar.addClass('fixed');
				$header.addClass('sticky-header');
				$header.removeClass('has-scrolled');
			}

			if ($header.hasClass('top-bar-visible')) {
				var headerHeight = isMobile ? 95 : 0;
			} else {
				var headerHeight = 0;
			}

			if (current_scroll <= headerTop+headerHeight || last_scroll < current_scroll) {
				$adminBar.removeClass('fixed');
				$header.removeClass('sticky-header');
				if (current_scroll > 80) {
					$header.addClass('has-scrolled');
				}
			}
			if (current_scroll <= headerTop+headerHeight) {
				$header.removeClass('has-scrolled');
			}
			last_scroll = current_scroll;

			if (sidebarHeight) {
				if (jQuery(window).scrollTop() > sidebarOffset) {
					jQuery('.bb-button-wrap').addClass('fixed-actions');
				}
				if (jQuery(window).scrollTop() <=  sidebarOffset) {
					jQuery('.bb-button-wrap').removeClass('fixed-actions');
				}
			}

		});
	}

	jQuery( '#menu-item-global a').hover( function (e, data) {
		jQuery( '#menu-item-global .ab-submenu').css('visibility', 'visible');
	});

	jQuery( '.bb-lms-pagination a').on('click', function (e, data) {
		jQuery('.bb-courses-directory').toggleClass('loading');
		jQuery('html, body').animate({scrollTop: 100}, 500);

		setTimeout(function(){
			jQuery('.bb-courses-directory').removeClass('loading');
			jQuery(window).trigger('learndash_pager_content_changed', {parent_div: '.bb-courses-directory'});

		}, 5000);
	});

	jQuery('.elementor-widget-scoolinary-courses input[name="current_page"]').change(function(){
		console.log('changed');
		jQuery(window).trigger('learndash_pager_content_changed', {parent_div: '.bb-courses-directory'});
	});


	jQuery(window).on('learndash_pager_content_changed',  function(e, params){
		console.log('learndash_pager_content_changed',params);
		jQuery('.bb-courses-directory').removeClass('loading');
		jQuery( '.bb-lms-pagination a').on('click', function (e, data) {
			jQuery('.bb-courses-directory').toggleClass('loading');
			jQuery(params.parent_div).animate({scrollTop: 100}, 500);
			setTimeout(function(){
				jQuery('.bb-courses-directory').removeClass('loading');
				jQuery(window).trigger('learndash_pager_content_changed', {parent_div: '.bb-courses-directory'});
			}, 5000);
		});
		attachFavoriteClickHandler();
	});

	function getIconHTML(iconType) {
        if (iconType === 'heart-full') {
            return '<i class="sc-icon-heart-full" aria-hidden="true"></i>';
        } else {
            return '<i class="sc-icon-heart" aria-hidden="true"></i>';
        }
    }

	function attachFavoriteClickHandler() {
		jQuery('.favorite-container .heart-icon, .favorite-recipe-wrapper').on('click', function(event) {
			let $this = jQuery(this);
			let objectId = $this.data('object-id');
			let typeObject = $this.data('type-object');
			let landingPage = $this.data('landing-page');
			let $button = $this.find('.favorite-recipe-button');
			let action = $this.find('i').hasClass('sc-icon-heart-full') ? 'remove' : 'add';

			if (isNaN(objectId) || parseInt(objectId) !== objectId) {
				console.error('Error: objectId is not a valid integer');
				return;
			}

			const validTypeObjects = ['recipes', 'techniques', 'sfwd-courses'];
			if (!validTypeObjects.includes(typeObject)) {
				console.error('Error: typeObject is not valid');
				return;
			}

			const validActions = ['add', 'remove'];
			if (!validActions.includes(action)) {
				console.error('Error: action is not valid');
				return;
			}

			if (landingPage) {
            
				if (action === 'add') {
					$button.addClass('active');
					
					$button.find('span[class^="icon-heart"]')
						.removeClass('icon-heart-normal')
						.addClass('icon-heart-favorite')
						.html(getIconHTML('heart-full'));
					
				} else {
					$button.removeClass('active');
					
					$button.find('span[class^="icon-heart"]')
						.removeClass('icon-heart-favorite')
						.addClass('icon-heart-normal')
						.html(getIconHTML('heart')); 
				}

			} else {

				const initialIconClass = action === 'add' ? 'sc-icon-heart' : 'sc-icon-heart-full';
				const newIconClass = action === 'add' ? 'sc-icon-heart-full' : 'sc-icon-heart';
				const newIcon = jQuery('<i>').addClass(newIconClass);
				$this.find('i').remove();
				$this.append(newIcon);

				const fav_page = getParameterByName('status');

				if (action === 'remove') {
					if (fav_page && fav_page === 'favorite') {
						$this.closest('.bb-course-item-wrap').fadeOut(500, function() {
							jQuery(this).remove();
						});
					}
					if (typeObject === 'techniques'){
						$this.closest('.bb-course-item-wrap').fadeOut(500, function() {
							jQuery(this).remove();
						});
					}
					if (typeObject === 'recipes'){
						$this.closest('.bb-course-item-wrap').fadeOut(500, function() {
							jQuery(this).remove();
						});
					}
				}
			}

			jQuery.ajax({
				url: bbReactionVars.ajax_url,
				type: 'POST',
				data: {
					action: 'bookmark_object',
					object_id: objectId,
					type_bookmark: typeObject,
					bookmark_action: action
				},
				success: function(response) {
					if (response.success) {
					} else {
						if(landingPage) {
							if (action === 'add') {
								$button.removeClass('active');
							} else {
								$button.addClass('active');
							}
							$button.find('span[class^="icon-heart"]').html(currentIcon);
						} else {
							console.error('Error update favorite');
							const initialIcon = jQuery('<i>').addClass(initialIconClass);
							$this.find('i').remove();
							$this.append(initialIcon);
						}
					}
				}
			});
		});
	}

	attachFavoriteClickHandler();

	function checkObjectMarked(objectId, typeObject, ) {

		if (isNaN(objectId) || parseInt(objectId) !== objectId) {
				console.log('Error: objectId is not a valid integer');
				return;
		}

		const validTypeObjects = ['recipes', 'techniques', 'sfwd-courses'];
		if (!validTypeObjects.includes(typeObject)) {
				console.log('Error: typeObject is not valid');
				return;
		}

		jQuery.ajax({
			url: bbReactionVars.ajax_url,
			type: 'POST',
			data: {
				action: 'bookmark_object',
				object_id: objectId,
				type_bookmark: typeObject,
				bookmark_action: 'is_marked'
			},
			success: function(response) {
				console.log(response);
				if (response.success) {
					console.log(response.data.marked);
				} else {
					console.log('Error checking favorite status');
				}
			}
		});
	}

	function getParameterByName(name) {
        name = name.replace(/[\[\]]/g, "\\$&");
        const url = window.location.href;
        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

	jQuery('input:radio[name=tab]').change(function () {
		jQuery('.search .post-grid').toggleClass('loading');
		jQuery(".search-form").submit();
	});
	jQuery('.search .nav-links').on('click', 'a', function (e) {
		jQuery('.search .post-grid').toggleClass('loading');
	});

	jQuery( document.body ).on( 'click', 'a.show-login', function (e) {
		jQuery( 'form.login, form.woocommerce-form--login' ).slideToggle();
	});


	jQuery('.load-popup').on('click', 'a', function (e) {
		var popup_id = jQuery(this).attr('rel');

		if(elementorFrontend.documentsManager.documents[popup_id] != undefined)
		elementorFrontend.documentsManager.documents[popup_id].showModal(); //show the popup

	 });


	 jQuery('.bb-toggle > a').on('click', function (e) {
		e.preventDefault();
		jQuery(this).siblings('.sub-menu').toggleClass('bb-open');
		jQuery(this).find('i').toggleClass('bs-submenu-open');

	 });

	jQuery( document ).on( 'elementor/popup/show', ( event, id, instance) => {

		var popup_rel = jQuery(event.currentTarget.activeElement).attr("rel");

		if(popup_rel != undefined){
			jQuery(instance.$element).find("input[name=redirect]").val(popup_rel);
		}

		jQuery('.elementor-element a.close-popup').on('click', function(event){
			elementorProFrontend.modules.popup.closePopup( {}, event);
		});

    /*
		jQuery(".elementor-form-fields-wrapper  button[type=submit]").on('click',function(e){
			if(jQuery(this).hasClass('loading') ){
				e.preventDefault();
				return;
			}
			jQuery(this).addClass('loading');
		});
    */

		jQuery( ".elementor-form-fields-wrapper  .show-password-input" ).on( 'click', function() {
				if ( jQuery( this ).hasClass( 'display-password' ) ) {
					jQuery( this ).removeClass( 'display-password' );
				} else {
					jQuery( this ).addClass( 'display-password' );
				}
				if ( jQuery( this ).hasClass( 'display-password' ) ) {
					jQuery( this ).siblings( ['input[type="password"]'] ).prop( 'type', 'text' );
				} else {
					jQuery( this ).siblings( 'input[type="text"]' ).prop( 'type', 'password' );
				}
			}
		);
	});

	if ($bb_course_video.length && typeof $bb_course_video.magnificPopup !== "undefined") {
		$bb_course_video.magnificPopup({
				type: 'iframe',
				iframe: {
						markup: '<div class="mfp-iframe-scaler">'+
										'<div class="mfp-close"></div>'+
										'<iframe class="mfp-iframe" frameborder="0" scrolling="no" marginwidth="0" marginheight="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allow="autoplay" frameborder="no"></iframe>'+
									'</div>',
				},
				callbacks: {
						open: function () {
								jQuery.magnificPopup.instance.close = function () {
										if (jQuery('.mfp-container .mfp-content .bb_course_video_details video'.length)) {
												jQuery.magnificPopup.proto.close.call(this);
										}
								};
						},
						close: function () {


						}
				}
		});
	}



	jQuery(".type-writer").each(function() {
        typeWriterEffect(jQuery(this), 0, 0);
    });

    function typeWriterEffect(element, index, textIndex) {
        const texts = element.data("texts");
        const typingSpeed = 70;

        element.addClass("typewriter-shadow");

        if (index < texts[textIndex].length) {
            element.html(element.html() + texts[textIndex].charAt(index));
            index++;
            setTimeout(() => typeWriterEffect(element, index, textIndex), typingSpeed);
        } else {
            element.removeClass("typewriter-shadow");
            setTimeout(() => {
                element.html("");
                textIndex = (textIndex + 1) % texts.length; // Loop through texts
                typeWriterEffect(element, 0, textIndex);
            }, 5000);
        }
    }

	//Print recipe button
	function hideEmptyElements() {
        jQuery('.recipes-ingredients, .recipes-preparation, .recipes-ingredientss').each(function() {
            if (jQuery(this).text().trim() === '') {
                jQuery(this).hide();
            }
        });
    }

    function showAllElements() {
        jQuery('.recipes-ingredients, .recipes-preparation, .recipes-ingredientss').show();
    }

    // Initially hide empty elements


    jQuery('#print-recipe-button').on('click', function (e) {
        e.preventDefault();
        hideEmptyElements();
        
        window.print();
        
        // Revert changes after printing
        window.onafterprint = function() {
            showAllElements();
        };
    });
});